module.exports = __webpack_public_path__ + "static/img/footer.179a3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer.png
// module id = FBBW
// module chunks = 0